import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Col, Image, Typography, Row as AntRow } from 'antd';
import styled, { ITheme } from 'styled-components';
import Slider from 'react-slick';
import { apiGetCurrentPool } from 'src/modules/Pool/redux/Pool.service';
import { apiGetInoByStatus } from 'src/modules/Collections/redux/Collections.service';
import { BTNPrimary } from 'src/components/Button';
import Loading from 'src/components/Loading';
import { ReactComponent as WebsiteSvg } from 'src/assets/svg/social/website.svg';
import { ReactComponent as TwitterSvg } from 'src/assets/svg/social/twitter.svg';
import { ReactComponent as TelegramSvg } from 'src/assets/svg/social/telegram.svg';
import { ReactComponent as MediumSvg } from 'src/assets/svg/social/medium.svg';
import { ReactComponent as DiscordSvg } from 'src/assets/svg/social/discord.svg';
import { isMobile } from 'react-device-detect';
import NoTokenLive from 'src/components/NoTokenLive/NoTokenLive';

const { Text, Link } = Typography;

const Section = styled.div`
    .link-social {
        display: unset;
    }
    .current-pool {
        margin: 0 auto;
        margin-top: 160px;
        max-width: 1272px;
        .current-project {
            width: 100%;
            justify-content: space-between;
            padding-bottom: 40px;
        }

        .product-item-v2 {
            position: relative;
            display: flex;
            justify-content: center;
            .content-product-item {
                position: absolute;
                bottom: 0;
                right: 0;
                left: 0;
                border-bottom-left-radius: 8px;
                border-bottom-right-radius: 8px;
                background: #ffffffcf;
                display: flex;
                align-items: center;
                padding: 20px 80px;
                .left-box {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .name-title {
                        display: flex;
                        align-items: center;

                        .project-logo {
                            width: 55px;
                            height: 55px;
                        }
                    }
                    .social {
                        svg {
                            margin-right: 20px;
                            width: 20px;
                        }
                    }
                }

                .right-box {
                    .btn-pools {
                        width: 100px;
                        height: 40px;
                        color: ${({ theme }: { theme: ITheme }) => theme.text1};
                        border: none;
                        background: ${({ theme }: { theme: ITheme }) => theme.black};
                    }
                }
            }
        }

        ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
            .product-item-v2 {
                position: relative;
                display: unset;
                .content-product-item {
                    position: unset;
                    border-bottom-left-radius: 8px;
                    border-bottom-right-radius: 8px;
                    display: flex;
                    align-items: center;
                    margin-top: -6px;
                    padding: 12px 10px;
                    .left-box {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        justify-content: space-between;

                        .name-title {
                            display: flex;
                            align-items: center;

                            .project-logo {
                                width: 35px;
                                height: 35px;
                                img {
                                    width: 35px;
                                    height: 35px;
                                }
                            }
                            .project-name {
                                font-weight: 600;
                                font-size: 16px;
                                line-height: 24px;
                            }
                        }
                        .social {
                            margin-left: 38px;
                            svg {
                                margin-right: 20px;
                                width: 20px;
                            }
                        }
                    }

                    .right-box {
                        .btn-pools {
                            width: 80px;
                            height: 32px;
                            border: none;
                        }
                    }
                }
            }
        `}

        .current-project-fieldset {
            width: 100%;
            border: 0.5px solid ${({ theme }: { theme: ITheme }) => theme.green2};
            border-radius: 8px;
            .fieldset-title {
                width: 27%;
                color: ${({ theme }: { theme: ITheme }) => theme.white};
                margin-left: 100px;
                padding-left: 20px;
                .title-live {
                    font-family: 'Orbitron';
                    font-style: normal;
                    font-weight: 700;
                    font-size: 52px;
                    line-height: 66px;
                    letter-spacing: 0.02em;
                    color: ${({ theme }: { theme: ITheme }) => theme.text3};
                }
                .title-sales {
                    color: ${({ theme }: { theme: ITheme }) => theme.white};
                }
            }
        }

        .slider-project {
            width: 100%;
            .slick-next {
                right: 20px;
            }
            .slick-prev {
                left: 20px;
                z-index: 3;
            }
            .slick-list {
                padding-bottom: 15px;
            }
            .slick-dots {
                bottom: -30px;
                .slider-dot-custom {
                    .slick-active {
                        width: 32px;
                        height: 8px;
                        background: ${({ theme }: { theme: ITheme }) => theme.text2};
                        border-radius: 4px;
                        .slider-dot-custom-item {
                            display: none;
                        }
                    }
                    li {
                        width: 8px;
                        height: 8px;
                        .slider-dot-custom-item {
                            width: 8px;
                            height: 8px;
                            border-radius: 50%;
                            border: 1px solid ${({ theme }: { theme: ITheme }) => theme.text2};
                        }
                    }
                }
            }
        }

        .project {
            margin: 0 auto;
            // margin-top: 20px;
            // min-width: 350px;
            & ~ .project {
                // margin-left: 24px;
            }
        }

        .project-status {
            position: absolute;
            top: 15px;
            right: 15px;
            cursor: default;
            height: 32px;
            margin: 0;
            width: fit-content;
            min-width: 120px;

            background: ${({ theme }: { theme: ITheme }) => theme.blue1};
        }

        .project-item {
            display: flex;
            flex-direction: column;
            height: 100%;

            background: ${({ theme }: { theme: ITheme }) => theme.dark7};
            border-radius: 20px;
            overflow: hidden;
            &:hover {
                box-shadow: 2px 2px 6px rgba(75, 201, 240, 0.24), 2px 2px 20px rgba(75, 201, 240, 0.7);
            }
        }

        .project-item:first-child {
            margin-left: 0;
        }

        .project-item:last-child {
            margin-right: 0;
        }

        .project-cover {
            max-height: 450px;
            overflow: hidden;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
        }

        .project-logo {
            margin-left: 0px;
            margin-top: 0%;
            border: 2px solid ${({ theme }: { theme: ITheme }) => theme.text6};
            border-radius: 50%;
            width: 72px;
            height: 72px;
            overflow: hidden;
        }

        .project-logo .ant-image-img {
            object-fit: cover;
            height: -webkit-fill-available;
        }

        .project-start {
            margin-top: -28px;
            padding-left: 10px;
            padding-right: 10px;
            max-height: 29px;
            background: ${({ theme }: { theme: ITheme }) => theme.dark2}60;
            backdrop-filter: blur(27.1828px);
            justify-content: space-between;
        }

        .project-start .ant-typography {
            color: ${({ theme }: { theme: ITheme }) => theme.text6};
        }

        .project-start-text {
            flex: 1;
            margin-left: 10px;
        }

        .project-name {
            color: ${({ theme }: { theme: ITheme }) => theme.text};
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: 32px;
            letter-spacing: 0px;
            text-align: left;
            margin-left: 5px;
        }

        .project-content {
            padding: 10px 20px 20px;
        }

        .project-details {
            justify-content: space-between;
            padding: 10px 0 0;
        }

        .project-text-label {
            color: ${({ theme }: { theme: ITheme }) => theme.dark3};
        }

        .project-text-value {
            color: ${({ theme }: { theme: ITheme }) => theme.text7};
        }

        .hero-content-title {
            color: ${({ theme }: { theme: ITheme }) => theme.text7};
            font-size: 48px;
            line-height: 55px;
        }
    }

    ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
        .current-pool {
            margin: 0 auto;
            margin-top: 40px;
            padding: 0 12px;
            max-width: 100%;
            .current-project-fieldset {
                width: 100%;
                border: none;
                .fieldset-title {
                    width: 100%;
                    text-align: center;
                    margin-left: 0;
                    padding-left: 0;
                    .title-live {
                        font-family: 'Orbitron';
                        font-style: normal;
                        font-weight: 700;
                        font-size: 22px;
                        line-height: 32px;
                        letter-spacing: 0.02em;
                    }
                }
            }
            .slider-project {
                width: 100%;
                height: 100%;
                .slick-arrow {
                    display: none !important;
                }
                .slick-list {
                    padding-bottom: 15px;
                }
                .slick-dots {
                    bottom: -30px;
                    .slider-dot-custom {
                        .slick-active {
                            width: 32px;
                            height: 8px;
                            background: ${theme.text2};
                            border-radius: 4px;
                            .slider-dot-custom-item {
                                display: none;
                            }
                        }
                        li {
                            width: 8px;
                            height: 8px;
                            .slider-dot-custom-item {
                                width: 8px;
                                height: 8px;
                                border-radius: 50%;
                                border: 1px solid ${theme.text2};
                            }
                        }
                    }
                }
            }
            .current-project {
                width: 100%;
                margin-top: 30px;
                // justify-content: space-evenly;
            }
            .project {
                width: 100%;
                // margin-top: 20px;
                // min-width: 360px;
                & ~ .project {
                    // margin-left: 24px;
                }
            }

            .project-status {
                position: absolute;
                top: 15px;
                right: 15px;
                cursor: default;
                height: 32px;
                margin: 0;
                width: fit-content;
                min-width: 120px;
            }

            .project-item {
                display: flex;
                flex-direction: column;
                height: 100%;
                border-radius: 20px;
                overflow: hidden;
            }

            .project-item:first-child {
                margin-left: 0;
            }

            .project-item:last-child {
                margin-right: 0;
            }

            .project-cover {
                max-height: 200px;
                overflow: hidden;
            }

            .project-logo {
                margin-left: 0px;
                margin-top: 0%;
                border-radius: 50%;
                width: 72px;
                height: 72px;
                overflow: hidden;
            }

            .project-logo .ant-image-img {
                object-fit: cover;
                height: -webkit-fill-available;
            }

            .project-start {
                margin-top: -28px;
                padding-left: 10px;
                padding-right: 10px;
                max-height: 29px;
                backdrop-filter: blur(27.1828px);
                justify-content: space-between;
            }

            .project-start .ant-typography {
            }

            .project-start-text {
                flex: 1;
                margin-left: 10px;
            }

            .project-name {
                font-size: 24px;
                font-style: normal;
                font-weight: 600;
                line-height: 32px;
                letter-spacing: 0px;
                text-align: left;
            }

            .project-content {
                padding: 10px 20px 20px;
            }

            .project-details {
                justify-content: space-between;
                padding: 10px 0 0;
            }

            .project-text-label {
            }

            .project-text-value {
            }
        }
    `}
`;

const PoolV2 = ({ pool }: any) => {
    const history = useHistory();
    return (
        <div className="product-item-v2">
            <Image wrapperClassName="project-cover" preview={false} src={pool.Image} />
            <div className="content-product-item">
                <div className="left-box">
                    <div className="name-title">
                        <Image wrapperClassName="project-logo" preview={false} src={pool.Thumb} />
                        <Text className="project-name">{pool.SaleTitle}</Text>
                    </div>
                    <div className="social">
                        {pool.LinkWebsite && (
                            <Link className="link-social" href={`https://${pool.LinkWebsite}`} target="_blank">
                                <WebsiteSvg />
                            </Link>
                        )}
                        {pool.LinkTwiter && (
                            <Link
                                className="link-social"
                                href={`https://twitter.com/${pool.LinkTwiter}`}
                                target="_blank"
                            >
                                <TwitterSvg />
                            </Link>
                        )}
                        {pool.LinkTelegram && (
                            <Link className="link-social" href={`https://t.me/${pool.LinkTelegram}`} target="_blank">
                                <TelegramSvg />
                            </Link>
                        )}
                        {pool.LinkMedium && (
                            <Link className="link-social" href={`${pool.LinkMedium}`} target="_blank">
                                <MediumSvg />
                            </Link>
                        )}
                        {pool.LinkDiscord && (
                            <Link className="link-social" href={`${pool.LinkDiscord}`} target="_blank">
                                <DiscordSvg />
                            </Link>
                        )}
                    </div>
                </div>
                <div className="right-box">
                    <BTNPrimary
                        className="btn-pools"
                        onClick={() => {
                            history.push(`/join-ido/${pool.SocialUrl}`);
                        }}
                        title="Join now"
                    />
                </div>
            </div>
        </div>
    );
};

const PoolInoV2 = ({ pool }: any) => {
    const history = useHistory();
    return (
        <div className="product-item-v2">
            <Image wrapperClassName="project-cover" preview={false} src={pool.Image} />
            <div className="content-product-item">
                <div className="left-box">
                    <div className="name-title">
                        <Image wrapperClassName="project-logo" preview={false} src={pool.Thumb} />
                        <Text className="project-name">{pool.SaleTitle}</Text>
                    </div>
                    <div className="social">
                        {pool.LinkWebsite && (
                            <Link className="link-social" href={`https://${pool.LinkWebsite}`} target="_blank">
                                <WebsiteSvg />
                            </Link>
                        )}
                        {pool.LinkTwiter && (
                            <Link
                                className="link-social"
                                href={`https://twitter.com/${pool.LinkTwiter}`}
                                target="_blank"
                            >
                                <TwitterSvg />
                            </Link>
                        )}
                        {pool.LinkTelegram && (
                            <Link className="link-social" href={`https://t.me/${pool.LinkTelegram}`} target="_blank">
                                <TelegramSvg />
                            </Link>
                        )}
                        {pool.LinkMedium && (
                            <Link className="link-social" href={`${pool.LinkMedium}`} target="_blank">
                                <MediumSvg />
                            </Link>
                        )}
                        {pool.LinkDiscord && (
                            <Link className="link-social" href={`${pool.LinkDiscord}`} target="_blank">
                                <DiscordSvg />
                            </Link>
                        )}
                    </div>
                </div>
                <div className="right-box">
                    <BTNPrimary
                        className="btn-pools"
                        onClick={() => {
                            history.push(`/ino/${pool.Slug}`);
                        }}
                        title="Join now"
                    />
                </div>
            </div>
        </div>
    );
};

const CurrentPoolV2 = () => {
    const [poolIdos, setPoolIdos] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const settings: any = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
        // autoplay: true,
        cssEase: 'linear',
        appendDots: (dots: any) => (
            <div>
                <ul className="slider-dot-custom"> {dots} </ul>
            </div>
        ),
        customPaging: () => <div className="slider-dot-custom-item" />,
    };
    const getPoolInfo = async () => {
        try {
            setLoading(true);
            const listPool = await apiGetCurrentPool();
            const listIno = await apiGetInoByStatus(2); // Current INO
            const iNos = listIno?.result?.Items.map((e: any) => ({ ...e, isIno: true }));
            let data = listPool?.result?.Items.concat(iNos);
            data = data.sort((a: any, b: any) => b.OpenTime.localeCompare(a.OpenTime)); // OpenTime
            setPoolIdos(data);
            setLoading(false);
        } catch (error: any) {
            setLoading(false);
            console.log('error: ', error);
        }
    };

    useEffect(() => {
        getPoolInfo();
    }, []);
    if (loading) {
        return <></>;
    }
    if (poolIdos.length === 0) {
        return (
            <NoTokenLive
                mtTop={isMobile ? 60 : 160}
                data-aos="fade-up"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
                data-aos-duration="500"
            />
        );
    }
    return (
        <Section
            id="current-pool"
            data-aos="fade-up"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
            data-aos-duration="500"
        >
            {loading && (
                <div style={{ height: 1000 }}>
                    <Loading />
                </div>
            )}
            {!loading && poolIdos.length !== 0 && (
                <div className="current-pool">
                    <fieldset className="current-project-fieldset">
                        <legend className="fieldset-title">
                            <span className="title-live">Live</span>
                            <span className="title-sales title-live"> sales</span>
                        </legend>
                        <AntRow className="home-section wrap-content-home-section">
                            <AntRow className="current-project">
                                <Slider className="slider-project" {...settings}>
                                    {poolIdos.map((pool: any) => {
                                        return (
                                            <>
                                                <Col key={pool.ID} className="project" xs={24} lg={20}>
                                                    {pool.isIno ? <PoolInoV2 pool={pool} /> : <PoolV2 pool={pool} />}
                                                </Col>
                                            </>
                                        );
                                    })}
                                </Slider>
                            </AntRow>
                        </AntRow>
                    </fieldset>
                </div>
            )}
        </Section>
    );
};

export default CurrentPoolV2;
